// =====================================================================
// Signup plan pricing
// =====================================================================
// Reads the live monthly price for Solo and Clinic from the database so
// the signup card always reflects what Superadmin has configured.
// Calls the anon-callable public.signup_plan_pricing() RPC which wraps
// dos_v2.tenant_billing_price_decision for both plans.
// =====================================================================

import { supabase } from "./supabaseClient";

export const SIGNUP_PRICING_LOADING = "loading";
export const SIGNUP_PRICING_UNAVAILABLE = "unavailable";

/**
 * Fetch live Solo + Clinic monthly pricing from the database.
 * Returns the parsed payload on success.
 * On error, returns null so the caller can show an "unavailable" state
 * rather than a misleading hardcoded number.
 */
export async function fetchSignupPlanPricing() {
  const { data, error } = await supabase.rpc("signup_plan_pricing");
  if (error || !data || !data.solo || !data.clinic) {
    if (error) {
      // eslint-disable-next-line no-console
      console.error("[signupPlanPricing] RPC failed:", error.message ?? error);
    }
    return null;
  }
  return {
    solo: normalize(data.solo, "solo"),
    clinic: normalize(data.clinic, "clinic"),
  };
}

function normalize(row, expectedKey) {
  return {
    plan_code: row.plan_code ?? expectedKey,
    monthly_price_centavos:
      row.monthly_price_centavos === null || row.monthly_price_centavos === undefined
        ? null
        : Number(row.monthly_price_centavos),
    is_founding_rate: Boolean(row.is_founding_rate),
    founding_slots_remaining:
      row.founding_slots_remaining === null || row.founding_slots_remaining === undefined
        ? null
        : Number(row.founding_slots_remaining),
    currency: row.currency ?? "PHP",
    trial_days: row.trial_days ?? 14,
  };
}

/**
 * Format a centavo amount as a Philippine peso string ("₱1,499").
 * Returns an empty string for null/undefined so callers can fall back
 * to a placeholder.
 */
export function formatPesos(centavos) {
  if (centavos === null || centavos === undefined) return "";
  const pesos = Math.round(centavos / 100);
  return "₱" + pesos.toLocaleString("en-PH");
}
